import React from 'react';
import { Renacida } from './pages/Renacida';
export function App() {
  return <Renacida data-id="element-0" />;
}